export interface BarberRow {

	id: number;
	barber: string;
	isSystem_0: boolean;

	created: Date;
	modified: Date;

	MonSTART: string;
	MonEND: string;
	TueStart: string;
	TueEND: string;
	WedStart: string;
	WedEND: string;
	ThuStart: string;
	ThuEND: string;
	FriSTART: string;
	FriEND: string;
	SatStart: string;
	SatEND: string;
	SunStart: string;
	SunEND: string;
}

const _now = new Date();

export class Barber {

	id: number;
	name: string;
	system: boolean;

	created: number;
	modified: number;

	schedule: Map<number /* day of the week: 0-6 */, {start: Date, end: Date}>

	constructor(
		row: BarberRow
	) {
		const now = _now;

		this.system = !!row.isSystem_0;
		this.name = row.barber;
		this.id = row.id;

		this.created = row.created.getTime();
		this.modified = row.modified.getTime();

		this.schedule = new Map([
			[0, {start: this._fixTime(row.SunStart, now), end: this._fixTime(row.SunEND, now)}],
			[1, {start: this._fixTime(row.MonSTART, now), end: this._fixTime(row.MonEND, now)}],
			[2, {start: this._fixTime(row.TueStart, now), end: this._fixTime(row.TueEND, now)}],
			[3, {start: this._fixTime(row.WedStart, now), end: this._fixTime(row.WedEND, now)}],
			[4, {start: this._fixTime(row.ThuStart, now), end: this._fixTime(row.ThuEND, now)}],
			[5, {start: this._fixTime(row.FriSTART, now), end: this._fixTime(row.FriEND, now)}],
			[6, {start: this._fixTime(row.SatStart, now), end: this._fixTime(row.SatEND, now)}],
		]);
	}

	private _fixTime(time: string, date: Date = new Date()): Date {
		if (!time) return null;
		const chunks = time.split(' ');
		if (!chunks.length) return null;
		const d = new Date(date),
			left = chunks[0].split(':').map(c => +c),
			am = chunks[1].toLowerCase() === 'am',
			minutes = left[1];
		let hours = left[0];
		if (hours === 12 && am) {
			hours = 0;
		} else if (!am && hours !== 12) {
			hours += 12;
		}
		d.setHours(hours, minutes, 0, 0);

		return d;
	}
}